import React from 'react';
import IcomoonReact from 'icomoon-react';
import iconSet from './selection.json';

const Icon = ({ className, color, size, name }) => {
  return (
    <IcomoonReact
      className={className}
      iconSet={iconSet}
      color={color}
      size={size}
      icon={name}
    />
  );
};

export default Icon;
